import { css } from 'styled-components';

const DefaultTextCSS = css`
  display: inline-flex;
  align-items: center;
  font-family: 'Noto Sans CJK KR', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell,
    'Open Sans', 'Helvetica Neue', sans-serif;
  color: ${({ color, theme }) => color || theme.colors.ui_on_1};
`;

const Headline1 = css`
  ${DefaultTextCSS}
  font-size: ${({ theme }) => theme.fontSizes.xxxxl}px;
  font-weight: ${({ theme }) => theme.fontWeights.bold};
  line-height: 31px;
`;

const Headline2 = css`
  ${DefaultTextCSS}
  font-size: ${({ theme }) => theme.fontSizes.xxxl}px;
  font-weight: ${({ theme }) => theme.fontWeights.bold};
  line-height: 48px;
`;

const Title1 = css`
  ${DefaultTextCSS}
  font-size: ${({ theme }) => theme.fontSizes.xxl}px;
  font-weight: ${({ theme }) => theme.fontWeights.bold};
  line-height: 27px;
`;

const Title2 = css`
  ${DefaultTextCSS}
  font-size: ${({ theme }) => theme.fontSizes.xl}px;
  font-weight: ${({ theme }) => theme.fontWeights.bold};
  line-height: 22px;
`;

const Title3 = css`
  ${DefaultTextCSS}
  font-size: ${({ theme }) => theme.fontSizes.lg}px;
  font-weight: ${({ theme }) => theme.fontWeights.medium};
  line-height: 20px;
`;

const BodyB = css`
  ${DefaultTextCSS}
  font-size: ${({ theme }) => theme.fontSizes.md}px;
  font-weight: ${({ theme }) => theme.fontWeights.bold};
  line-height: 20px;
`;

const BodyM = css`
  ${DefaultTextCSS}
  font-size: ${({ theme }) => theme.fontSizes.md}px;
  font-weight: ${({ theme }) => theme.fontWeights.medium};
  line-height: 20px;
`;

const BodyR = css`
  ${DefaultTextCSS}
  font-size: ${({ theme }) => theme.fontSizes.md}px;
  font-weight: ${({ theme }) => theme.fontWeights.regular};
  line-height: 22px;
`;

const FootnoteB = css`
  ${DefaultTextCSS}
  font-size: ${({ theme }) => theme.fontSizes.sm}px;
  font-weight: ${({ theme }) => theme.fontWeights.bold};
  line-height: 16px;
`;

const FootnoteM = css`
  ${DefaultTextCSS}
  font-size: ${({ theme }) => theme.fontSizes.sm}px;
  font-weight: ${({ theme }) => theme.fontWeights.medium};
  line-height: 16px;
  letter-spacing: -0.3px;
`;

const FootnoteR = css`
  ${DefaultTextCSS}
  font-size: ${({ theme }) => theme.fontSizes.sm}px;
  font-weight: ${({ theme }) => theme.fontWeights.regular};
  line-height: 16px;
  letter-spacing: -0.3px;
`;

const Caption1 = css`
  ${DefaultTextCSS}
  font-size: ${({ theme }) => theme.fontSizes.xs}px;
  font-weight: ${({ theme }) => theme.fontWeights.medium};
  line-height: 16px;
  letter-spacing: -0.3px;
`;

const TextCSS = {
  Headline1,
  Headline2,
  Title1,
  Title2,
  Title3,
  BodyB,
  BodyM,
  BodyR,
  FootnoteB,
  FootnoteM,
  FootnoteR,
  Caption1,
};

export default TextCSS;
